import api from 'shared/api';

export const fetchCustomFields = (licenseId) => {
  const url = `/api/v1/license-custom-fields/?license=${licenseId}`;
  return api.get(url);
};
